import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Box,
  Radio,
  FormControlLabel,
  Divider,
  IconButton,
  LinearProgress
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  allModelsLoadingState,
  allModelsState,
  displayModelState,
  S3File
} from 'features/file-browser/state/fileAtoms';
import { isVisibleModelState } from 'features/three-view/state/threeAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  subtitle: string;
}

const iconSx = {
  fontSize: 12,
  color: '#e1e1e1'
};

const boxSx = {
  backgroundColor: '#404040',
  borderRadius: '5px',
  height: '80%',
  overflow: 'auto',
};

const radioSx = {
  color: '#e9e9e9',
  '&.Mui-checked': {
    color: '#1976d2',
  },
  transform: 'scale(.9)',
};

export const DisplayModelPanel: React.FC<Props> = ({
  subtitle,
}) => {
  const [displayModel, setDisplayModel] = useRecoilState(displayModelState);
  const [isVisibleModel, setisVisibleModel] = useRecoilState(isVisibleModelState);
  const allModels = useRecoilValue(allModelsState);
  const loading = useRecoilValue(allModelsLoadingState);

  const handleToggle = () => {
    setisVisibleModel((prev) => !prev);
  };

  const handleRadioChange = (file: S3File) => {
    setDisplayModel(file);
  };

  return (
    loading ? (
      <Box component="div" >
        <LinearProgress />
      </Box>
    ) : (
      <Box component="div" sx={{ height: '100%', width: '100%' }}>

        <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '8%' }}>
          <CustomTypography >{subtitle}</CustomTypography>
          <IconButton onClick={handleToggle}>
            {isVisibleModel ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
          </IconButton>
        </Box>

        <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

        <Box component="div" sx={boxSx}>
          {allModels.map((file) => (
            <Box key={file.name} component="div" sx={{ display: 'flex', alignItems: 'center', mb: -2, ml: 2 }}>
              <FormControlLabel
                control={
                  <Radio
                    sx={radioSx}
                    checked={displayModel?.name === file.name}
                    onChange={() => handleRadioChange(file)}
                    name="fileSelection"
                  />
                }
                label={<CustomTypography>{file.name}</CustomTypography>}
              />
            </Box>
          ))}
        </Box>

      </Box>
    )
  );
};
